<script lang="ts">
  import Pusher from "pusher-js";
  import Logo from "./Logo.svelte";
  export const ssr = false;

  let sites: string[] = ["https://www.nos.nl"];
  const pusher = new Pusher("ae4dcf4e3f46f218c391", {
    cluster: "eu",
  });

  const channel = pusher.subscribe("my-channel");
  channel.bind("add", (data: string) => (sites = [...sites, data]));
  channel.bind("goto", (data: string) => goToSite(data));

  const goToSite = (id: string): void => {
    document.getElementById(id).scrollIntoView({
      behavior: "smooth",
      inline: "nearest",
      block: "nearest",
    });
  };
</script>

<div class="slider">
  {#each sites as src}
    <section id={src} class="child">
      <div class="branding">
        <Logo />
        <p>{src}</p>
      </div>
      <iframe title={src} {src} />
    </section>
  {/each}
</div>

<style>
  :global(*) {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .slider {
    background: #4840bb26;
    font-family: sans-serif;

    display: flex;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;

    content-visibility: auto;
    contain-intrinsic-size: 100vw;
  }

  :global(body) {
    overflow: hidden;
  }

  div.branding {
    height: 5vh;
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    justify-content: flex-start;
  }

  div.branding p {
    margin-left: 1rem;
    margin-top: 0.1125rem;
    font-size: 1.25rem;
    font-weight: 500;
    color: #4840bb;
  }

  div.branding p:first-of-type {
    letter-spacing: -0.0125em;
    text-transform: none;
  }

  section {
    padding: 1rem;
    min-width: 100vw;
    height: 100vh;
    scroll-snap-align: start;
    text-align: center;
    position: relative;
  }

  iframe {
    background: white;
    border-radius: 0.5rem;
    border: none;
    height: calc(95% - 1rem);
    width: 100%;
  }

  section {
    height: 100vh;
    width: 100vw;
    scroll-snap-align: start;
  }
</style>
